import Controller from 'controllers/controller';
import ModalController from 'controllers/modal';
import Elements from 'tools/elements';
import Bus from 'tools/bus';
import Binder from 'tools/binder';
import Animator from 'tools/animator';

class ModalsController extends Controller {
    constructor(app) {
        super(app);
        
        this.elements = new Elements;
        this.animator = new Animator({
            elements: this.elements.all()
        });
        this.bus = new Bus(this);
        this.binder = new Binder(this);
        
        this.modalControllersById = { };
        
        this.cacheElements();
        this.attachEvents();
    }
    
    cacheElements() {
        this.elements.queryOne('backdrop', '#jr-modal-backdrop');
        this.elements.queryAll('modals', '.jr-modal');
    }
    
    attachEvents() {
        this.on('open-modal', this.binder.bind('onOpenModal'));
        console.log(this.elements.get('backdrop'));
        this.elements.get('backdrop').addEventListener('click', this.binder.bind('onBackdropClick'));
        this.app.on('controllers-initialised', this.binder.bind('onAppControllersInitialised'));
    }

    onAppControllersInitialised() {
        // Only init when controllers are initialised so that ModalController instances may access this instance of
        // ModalsController via this.app.modalsController. Otherwise, when the ModalController's are instantiated, the
        // property 'modalsController' will not exist on the AppController instance yet.
        this.initModalControllers();
    }

    onBackdropClick() {
        this.emit('backdrop-clicked');
    }
    
    openModal(id) {
        this.emit('open-modal', id);
    }

    onOpenModal(id) {
        if ( ! this.modalControllersById[id]) {
            throw new Error('Invalid modal id passed');
        }
        
        this.modalControllersById[id].open();
    }

    initModalControllers() {
        this.elements.each('modals', modal => {
            this.initModalController(modal);
        });
    }
    
    initModalController(modal) {
        let id = modal.getAttribute('id');
        
        this.modalControllersById[id] = this.app.make(ModalController, modal);
    }
    
    showBackdrop() {
        this.animator.fromTo('backdrop', {
            display: 'block',
            opacity: 0
        }, {
            opacity: 1
        })
    }
    
    hideBackdrop() {
        this.animator.to('backdrop', {
            opacity: 0,
            onComplete: () => {
                this.animator.set('backdrop', {
                    display: 'none'
                })
            }
        })
    }
}

export default ModalsController;